var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

SCM.SharedWidgets.TrendMD = (function ($) {
    return {
        init: hideTrendMdIfHumShows
    };

    function hideTrendMdIfHumShows() {
        hideTrendMDandHumWidgets();

        if (isHumWidgetEnabled() && hasUserAcceptedCookie()) {
            const humWait = Number($('.hum').data('humWait'));
            const humRetry = Number($('.hum').data('humRetry'));

            SCM.Retry
                .policy()
                .handleResult(function (result) { return !result; })
                .waitAndRetry(humRetry, humWait)
                .execute(isHumDataLoaded)
                .then(displayHumOrDefaultToTrend)
                .catch(() => {
                    displayTrendMDWidget();
                });
        }
        else {
            displayTrendMDWidget();
        }
    }

    function displayHumOrDefaultToTrend() {
        let suppressIfHumIsPresent = $('.widget-TrendMD .options').data('suppress-if-hum-is-present');

        if (suppressIfHumIsPresent && suppressIfHumIsPresent.toLowerCase() === 'false' && isHumDataLoaded()) {
            displayTrendMDandHumWidgets();
            return;
        }

        if (isHumDataLoaded()) {
            displayHumWidget();
            return;
        }
      
        displayTrendMDWidget();      
    }

    function hasUserAcceptedCookie() {
        const cookies = document.cookie.split('; ');
        for (var cookie of cookies) {
            if (cookie.startsWith('hum_')) {
                return true;
            }
        }
        return false;
    }

    function isHumWidgetEnabled() {
        return $('.hum').length > 0;
    }

    function isHumDataLoaded() {
        return $('.hum .hum-recommendations').length > 0;
    }

    function displayHumWidget() {
        $('.widget-Hum').removeClass('hide');
    }

    function displayTrendMDWidget() {
        $('.widget-TrendMD').removeClass('hide');
    }
   
    function displayTrendMDandHumWidgets() {
        $('.widget-TrendMD').removeClass('hide');
        $('.widget-Hum').removeClass('hide');
    }

    function hideTrendMDandHumWidgets() {
        $('.widget-TrendMD').addClass('hide');
        $('.widget-Hum').addClass('hide');
    }
})(jQuery);